import {
  FileArchiveIcon,
  FileAudioIcon,
  FileCodeIcon,
  FileCssIcon,
  FileCsvIcon,
  FileDocIcon,
  FileHtmlIcon,
  FileIcon,
  FileImageIcon,
  FileJpgIcon,
  FileJsIcon,
  FileMdIcon,
  FilePdfIcon,
  FilePngIcon,
  FilePptIcon,
  FilePyIcon,
  FileSqlIcon,
  FileSvgIcon,
  FileTextIcon,
  FileTsIcon,
  FileVideoIcon,
  FileXlsIcon,
  FileZipIcon,
  type Icon as PhosphorIcon,
} from '@phosphor-icons/react'

// Note: Keys are grouped by file category for readability rather than alphabetical order.
const FILE_ICON_MAP: Record<string, PhosphorIcon> = {
  // Documents
  pdf: FilePdfIcon,
  doc: FileDocIcon,
  docx: FileDocIcon,
  txt: FileTextIcon,
  rtf: FileTextIcon,
  md: FileMdIcon,
  // Spreadsheets
  xls: FileXlsIcon,
  xlsx: FileXlsIcon,
  csv: FileCsvIcon,
  // Presentations
  ppt: FilePptIcon,
  pptx: FilePptIcon,
  // Images
  png: FilePngIcon,
  jpg: FileJpgIcon,
  jpeg: FileJpgIcon,
  gif: FileImageIcon,
  svg: FileSvgIcon,
  webp: FileImageIcon,
  // Video
  mp4: FileVideoIcon,
  mov: FileVideoIcon,
  avi: FileVideoIcon,
  mkv: FileVideoIcon,
  // Audio
  mp3: FileAudioIcon,
  wav: FileAudioIcon,
  ogg: FileAudioIcon,
  // Code / markup
  html: FileHtmlIcon,
  css: FileCssIcon,
  js: FileJsIcon,
  ts: FileTsIcon,
  py: FilePyIcon,
  sql: FileSqlIcon,
  json: FileCodeIcon,
  xml: FileCodeIcon,
  // Archives
  zip: FileZipIcon,
  rar: FileArchiveIcon,
  gz: FileArchiveIcon,
  tar: FileArchiveIcon,
}

export const getFileIcon = (extension: string): PhosphorIcon => {
  const normalized = extension.toLowerCase().replace(/^\./, '')
  return FILE_ICON_MAP[normalized] ?? FileIcon
}
